
import visual from './modules/_coffret__visual';

//この根っこファイルに内容増えると嫌なので一応クロージャー

(() => {
  new visual();
})();
